// Canonical co-tutor relationship types. `value` is the stable key stored in
// the backend (co_tutors.relationshipType); `label` is the Spanish text shown
// in the admin UI. Keep this list in sync with pawer-app's relationship
// options — it is the single source of truth for both apps.
const RELATIONSHIP_TYPE_OPTIONS = [
  { label: 'Es su pareja / cónyuge', value: 'spouse' },
  { label: 'Es su padre', value: 'father' },
  { label: 'Es su madre', value: 'mother' },
  { label: 'Es su hermano/a', value: 'sibling' },
  { label: 'Es su hijo/a', value: 'child' },
];

// Plain noun form used for read-only display (table cells, co-tutor list
// labels) — distinct from `RELATIONSHIP_TYPE_OPTIONS.label`, which is phrased
// for a select dropdown ("Es su padre") and reads oddly outside a form.
const DISPLAY_LABEL_BY_VALUE = {
  spouse: 'Pareja / cónyuge',
  father: 'Padre',
  mother: 'Madre',
  sibling: 'Hermano/a',
  child: 'Hijo/a',
};

// Historical `relationshipType` values stored as free text (Spanish and
// English) before this fix, still present on records created before the
// migration that normalized them to the stable keys above.
const LEGACY_LABEL_TO_VALUE = {
  'Es mi pareja / cónyuge': 'spouse',
  'Pareja / Cónyuge': 'spouse',
  "They're my partner / spouse": 'spouse',
  'Es mi padre': 'father',
  'Es mi madre': 'mother',
  'Es mi hermano/a': 'sibling',
  'Hermano / Hermana': 'sibling',
  'Es mi hijo/a': 'child',
};

function displayRelationshipType(type) {
  if (!type) return '—';
  const value = DISPLAY_LABEL_BY_VALUE[type] ? type : LEGACY_LABEL_TO_VALUE[type];
  return DISPLAY_LABEL_BY_VALUE[value] || type;
}

export { RELATIONSHIP_TYPE_OPTIONS, displayRelationshipType };
